import React, { Component } from 'react';
import lang from '../lang/index';
import url from 'c-url';

class Contact extends Component {

	constructor(props) {
		super(props);
		this.state = {
			websiteid: 114402
		}

	}


	contact() {
		let language = url.query('language') ? url.query('language') : 'zh-CN';
		let websiteid;
		console.log(language);

		switch (language) {
			case 'vi-VN':
				websiteid = 114549;
				break;
			case 'ja-JP':
				websiteid = 118940;
				break;
			case 'ar-EG':
				websiteid = 118269;
				break;
			default:
				websiteid = 114402;
				break;
		}
		window.location.href = 'http://kefu.qycn.com/vclient/chat/?m=m&websiteid=' + websiteid;


	}

	render() {
		const fea = url.query('feature');
		const isHujing = fea == 224;

		return (
			<div></div>
			// <div className={ isHujing ? "contact-service-hj" : "contact-service" }>{lang.template('如验证出现问题，请联系upcs@asiainnovations.com')}</div>

		);
	}

}

export default Contact;



// WEBPACK FOOTER //
// ./js/view/contact.js